<template>
  <div class="page">

    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-header">
              <img :src="item.image" alt="Content Image" class="image" />
            </div>
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_1)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_2)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_2)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_3)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_3)" class="description"></div>
              <div v-html="formattedDescriptionNo(item.description_no_4)" class="description_no"></div>
              <div v-html="formattedDescription(item.description_4)" class="description"></div>
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div> 
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Section (moved to the right) -->
      <div class="contact-container">
        <h2>Contact Information</h2>
        <div class="contact-info">
          <i class="fas fa-phone"></i>
          <p>Phone: 暂无(E-mail Only)</p>
        </div>
        <div class="contact-info">
          <i class="fas fa-envelope"></i>
          <p>Email: dankao.chen@nxtech.pub</p>
        </div>
        <!-- Add more contact info as needed -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/cases.css" scoped></style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image: require("@/assets/img/PlanandCases/FilmTelevision/DreamWaterPage/FilmTelevision_DreamWater.jpg"),
            title: "虚拟制片：《梦之海》",
            description_no_1: `
               <strong class="bold-text">1. 引言</strong>
            `,
            description_1: `
            作为一个在影视技术领域具有深厚底蕴和前瞻视野的团队，我们团队长期致力于推动影视制作技术的创新与发展。凭借在虚拟制片技术领域的深厚积累与持续创新，我们在行业内树立了良好的口碑，并赢得了众多合作伙伴的信赖与认可。

            电视剧《梦之海》改编自刘慈欣创作的同名科幻小说，以近未来时期为时代背景，讲述了所有的地表水在毫无预兆的情况下升入太空，致使人类失去了海洋，面临生存危机。其拍摄过程对技术支持的要求极高。剧组希望借助先进的虚拟制片技术，打造出逼真且富有创意的视觉效果，以提升剧集的观赏体验。

            在了解到《梦之海》剧组的技术需求后，我们就合作事宜进行了深入的沟通与探讨。通过充分展示我们在虚拟制片技术方面的实力与成果，双方建立了互信的合作关系。
              `,
            description_no_2: `
               <strong class="bold-text">2. 虚拟制片技术</strong>
            `,
            description_2: `
            虚拟制片技术是一种利用计算机图形学、虚拟现实和增强现实等技术手段，在虚拟环境中进行影视拍摄与制作的技术。它能够在拍摄前对场景、角色、灯光等进行精确的模拟与预演，帮助导演和摄影师更好地把握拍摄效果，提高拍摄效率与质量。同时，虚拟制片技术还能够实现场景的无缝切换与特效的实时渲染，为观众带来更加震撼的视觉效果。作为虚拟制片行业的先行者，我们在虚拟制片技术领域取得了多项创新与突破。我们搭建了一套高效且易于操作的虚拟制片系统，能够实现对场景、角色、灯光等元素的精确控制与调整。
              `,
            description_no_3: `
               <strong class="bold-text">3. 技术实施过程中的挑战与解决方案</strong>
            `,
            description_3: `
            在虚拟制片技术的实施过程中，我们遭遇了一系列复杂而多样的挑战。这些挑战不仅来自于技术层面的复杂性，还涉及到团队协作、场景设计以及时间管理等多个方面。

            首先，电视剧《梦之海》的IP概念设计非常独特，包含了宇宙、冰川、末日废土等特殊场景。这些场景不仅要求我们在视觉上达到高度的真实感，还需要在剧情上保持连贯性和一致性。因此，我们需要根据剧情的需要，不断调整和优化虚拟场景，以确保它们在画面上的表现与故事情感相符合。这一过程需要大量的时间和精力投入，涉及到对场景细节的反复推敲和修改。

            其次，虚拟制片技术对于双方团队的协同合作水平提出了极高的要求。在制片过程中，我们团队与《梦之海》剧组进行了紧密的合作，通过定期的制片会议，共同商讨和解决虚拟场景制作中遇到的问题。我们为剧组提供了虚拍片段的全流程、全分镜拍摄指导建议，帮助导演和摄影师更好地理解如何在虚拟环境中进行拍摄。同时，我们还派遣了专业的技术人员参与拍摄流程，根据导演的指令动态调整背景屏幕中的显示效果，确保拍摄效果符合预期。

            此外，在虚拟制片技术的实施过程中，我们还面临了时间管理的挑战。由于电视剧的拍摄进度紧张，我们需要在既定的时间内完成所有虚拟场景的制作和拍摄任务。因此，我们需要制定详细的时间计划，合理安排各个阶段的工作进度，确保每个环节都能够按时完成。

            值得一提的是，虚拟制片技术的成功实施，也离不开云翰虹章团队在技术创新方面的努力。我们不断探索新的技术手段和解决方案，以提高虚拟场景的真实感和制作效率。例如，我们采用了先进的渲染技术和光影模拟技术，使得虚拟场景在视觉上更加逼真；同时，我们还开发了一套高效的多场景管理方案，方便团队成员对场景进行快速调整和优化。
              `,
            description_no_4: `
               <strong class="bold-text">4. 《梦之海》剧组的反馈与认可</strong>
            `,
            description_4: `
            电视剧《梦之海》剧组对我们的虚拟制片技术给予了高度评价。他们表示，通过运用虚拟制片技术，他们得以更加灵活地拍摄各种复杂场景，大大提高了拍摄效率和质量。同时，虚拟制片技术还为他们带来了更多的创意空间，使得剧集在视觉效果上呈现出前所未有的震撼与新奇。

            在技术应用过程中，剧组深刻体会到了虚拟制片技术的优势与魅力。他们表示，通过虚拟制片技术，他们能够更加直观地预览拍摄效果，及时发现并解决问题。同时，虚拟制片技术还为他们节省了大量的拍摄时间和成本，使得他们能够更加专注于剧情的打磨和角色的塑造。
            `,
            image_1: require("@/assets/img/PlanandCases/FilmTelevision/DreamWaterPage/XiangShan.jpg"),
            },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image: require("@/assets/img/PlanandCases/FilmTelevision/DreamWaterPage/FilmTelevision_DreamWater.jpg"),
            title: "Virtual production: Sea of Dreams",
            description_no_1: `
               <strong class="bold-text">1. Intro</strong>
            `,
            description_1: `
            As a team with deep heritage and forward-looking vision in the field of film and television technology, our team has long been committed to promoting the innovation and development of film and television production technology. With the deep accumulation and continuous innovation in the field of virtual production technology, we have established a good reputation in the industry and won the trust and recognition of many partners.

            Adapted from the science fiction novel of the same name written by Liu Cixin, the TV series Sea of Dreams is set in the near-future period and tells the story of how all the surface water rises into the space without any warning, resulting in mankind losing its oceans and facing an existential crisis. The filming process required a high level of technical support. The crew hoped to use advanced virtual production technology to create realistic and creative visual effects to enhance the viewing experience of the series.

            After understanding the technical needs of the cast and crew of Sea of Dreams, we had an in-depth communication and discussion on the cooperation. By fully demonstrating our strengths and achievements in virtual production technology, both parties established a mutual trust and cooperation relationship.
              `,
            description_no_2: `
               <strong class="bold-text">2. Virtual Film-making Technology</strong>
            `,
            description_2: `
            Virtual production technology is a kind of technology that makes use of computer graphics, virtual reality and augmented reality to shoot and produce film and television in a virtual environment. It can carry out accurate simulation and preview of scenes, roles, lights, etc. before shooting to help directors and cameramen better grasp the shooting effect and improve the shooting efficiency and quality. At the same time, virtual production technology can also achieve seamless scene switching and real-time rendering of special effects, bringing more shocking visual effects to the audience.

            As a pioneer in the virtual production industry, we have made a number of innovations and breakthroughs in the field of virtual production technology. We have built an efficient and easy-to-operate virtual production system that enables precise control and adjustment of scenes, characters, lighting and other elements.
              `,
            description_no_3: `
               <strong class="bold-text">3. Challenges and Solutions during Implementation</strong>
            `,
            description_3: `
            During the implementation of the virtual filming technology, we encountered a series of complex and varied challenges. These challenges not only came from the complexity of the technical level, but also involved a number of aspects such as teamwork, scene design and time management.

            Firstly, the IP concept design of the TV series Sea of Dreams is very unique, containing special scenes such as the universe, glaciers and apocalyptic wasteland. These scenes not only required us to achieve a high degree of visual realism, but also needed to maintain coherence and consistency in the plot. Therefore, we need to continuously adjust and optimise the virtual scenes according to the needs of the plot to ensure that their performance on the screen matches the story's emotion. This process requires a lot of time and effort, and involves repeated refinement and modification of scene details.

            Secondly, the virtual production technology puts high demands on the level of co-operation between the two teams. During the production process, our team worked closely with the cast and crew of Sea of Dreams, discussing and solving problems encountered in the production of virtual scenes through regular production meetings. We provided the crew with advice on the full process and split-screen shooting guidance for the virtual set footage, helping the director and cameraman better understand how to shoot in a virtual environment. At the same time, we also sent professional technicians to participate in the shooting process, dynamically adjusting the display effect in the background screen according to the director's instructions to ensure that the shooting effect meets the expectations.

            In addition, we faced the challenge of time management during the implementation of virtual production technology. Due to the tight shooting schedule of the TV series, we needed to complete the production and shooting tasks of all virtual scenes within the set time. Therefore, we need to formulate a detailed time plan and reasonably arrange the work progress of each stage to ensure that each link can be completed on time.
            
            It is worth mentioning that the successful implementation of virtual production technology is also inseparable from the efforts of Rosy Nebula team in technological innovation. We constantly explore new technical means and solutions to improve the realism of virtual scenes and production efficiency. For example, we adopted advanced rendering technology and light and shadow simulation technology to make the virtual scenes more visually realistic; at the same time, we also developed a set of efficient multi-scene management solutions to facilitate rapid adjustment and optimisation of scenes by team members.
              `,
            description_no_4: `
               <strong class="bold-text">4. Feedback and Recognition from the cast and crew of Sea of Dreams</strong>
            `,
            description_4: `
            The cast and crew of the TV series ‘Sea of Dreams’ spoke highly of our virtual filmmaking technology. They said that through the use of virtual production technology, they were able to shoot various complex scenes more flexibly, which greatly improved the shooting efficiency and quality. At the same time, the virtual production technology also brought them more creative space, which made the drama show unprecedented shock and novelty in visual effects.

            In the process of technology application, the crew deeply experienced the advantages and charm of virtual production technology. They said that through the virtual production technology, they were able to preview the shooting effect more intuitively and find and solve problems in time. At the same time, virtual production technology also saves them a lot of shooting time and cost, which enables them to focus more on the polishing of the plot and characterisation.
            `,
            image_1: require("@/assets/img/PlanandCases/FilmTelevision/DreamWaterPage/XiangShan.jpg"),
            },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>